export default __webpack_public_path__ + "fonts/iconfont.609d580933c7cf13a391a53b98dd31e2.ttf";